import { DynamicTypography } from 'src/components/DynamicTextTypography'
import { FilterContainer } from 'src/containers/Equipment/EquipmentListContainer'
import TextFilter from 'src/containers/Equipment/filters/TextFilter'
import DateFilter from 'src/containers/Equipment/filters/DateFilter'
import DropdownFilter from 'src/containers/Equipment/filters/DropdownFilter'

interface FilterHeaderProps {
  headerName: string
  field: string
  filterType?: 'text' | 'number' | 'date' | 'fulldate' | 'dropdown'
  placeholder?: string
  dropdownOptions?: Array<{ value: string | number; label: string }>
  loading?: boolean
  multiple?: boolean
  filters: Record<string, any>
  filterInputRefs: React.MutableRefObject<Record<string, HTMLInputElement | null>>
  updateFilter: (field: string, value: string | number | number[] | string[]) => void
  clearFilter: (field: string) => void
  handleChangeFields?: (event: React.SyntheticEvent, value: any, field: string, multiple: boolean) => void
  getCurrentValuesOfField?: (
    field: string,
    multiple: boolean,
    options: Array<{ value: number | string; label: string }>,
  ) => void
}

export const FilterHeader: React.FC<FilterHeaderProps> = ({
  headerName,
  field,
  filterType = 'text',
  placeholder,
  dropdownOptions = [],
  loading = false,
  multiple = false,
  filters,
  filterInputRefs,
  updateFilter,
  clearFilter,
  getCurrentValuesOfField,
  handleChangeFields,
}) => {
  const renderFilter = () => {
    switch (filterType) {
      case 'date':
        return <DateFilter field={field} headerFilters={filters} updateFilter={updateFilter} />
      case 'fulldate':
        return <DateFilter field={field} headerFilters={filters} updateFilter={updateFilter} mode='fullDate' />
      case 'dropdown':
        return (
          <DropdownFilter
            field={field}
            options={dropdownOptions}
            headerFilters={filters}
            updateFilter={updateFilter}
            loading={loading}
            multiple={multiple}
            getCurrentValuesOfField={getCurrentValuesOfField}
            handleChangeFields={handleChangeFields}
          />
        )
      default:
        return (
          <TextFilter
            field={field}
            placeholder={placeholder}
            type={filterType}
            headerFilters={filters}
            filterInputRefs={filterInputRefs}
            updateFilter={updateFilter}
            clearFilter={clearFilter}
          />
        )
    }
  }

  return (
    <FilterContainer>
      <DynamicTypography text={headerName} fontWeight={400} />
      {renderFilter()}
    </FilterContainer>
  )
}